var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 6,
    viewBox: "0 0 104 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.113249 3L3 5.88675L5.88675 3L3 0.113249L0.113249 3ZM3 3.5H4.01V2.5H3V3.5ZM6.03 3.5H8.05V2.5H6.03V3.5ZM10.07 3.5H12.09V2.5H10.07V3.5ZM14.11 3.5H16.13V2.5H14.11V3.5ZM18.15 3.5H20.17V2.5H18.15V3.5ZM22.19 3.5H24.21V2.5H22.19V3.5ZM26.23 3.5H28.25V2.5H26.23V3.5ZM30.27 3.5H32.29V2.5H30.27V3.5ZM34.31 3.5H36.33V2.5H34.31V3.5ZM38.35 3.5H40.37V2.5H38.35V3.5ZM42.39 3.5H44.41V2.5H42.39V3.5ZM46.43 3.5H48.45V2.5H46.43V3.5ZM50.47 3.5H52.49V2.5H50.47V3.5ZM54.51 3.5H56.53V2.5H54.51V3.5ZM58.55 3.5H60.57V2.5H58.55V3.5ZM62.59 3.5H64.61V2.5H62.59V3.5ZM66.63 3.5H68.65V2.5H66.63V3.5ZM70.67 3.5H72.69V2.5H70.67V3.5ZM74.71 3.5H76.73V2.5H74.71V3.5ZM78.75 3.5H80.77V2.5H78.75V3.5ZM82.79 3.5H84.81V2.5H82.79V3.5ZM86.83 3.5H88.85V2.5H86.83V3.5ZM90.87 3.5H92.89V2.5H90.87V3.5ZM94.91 3.5H96.93V2.5H94.91V3.5ZM98.95 3.5H100.97V2.5H98.95V3.5ZM102.99 3.5H104V2.5H102.99V3.5Z",
    fill: "#191818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine6);
export default __webpack_public_path__ + "static/media/line-6.23124be031f3b22332acb4da6c54b155.svg";
export { ForwardRef as ReactComponent };